import Link from "next/link";
import React from "react";
import { FaCaretDown } from "react-icons/fa";

import { menuItems, MenuItem } from "@/app/data/Menudata";
import CallPhone from "@/components/utilities/CallPhone";
import TwoButtonsLarge from "@/components/utilities/TwoButtonsLarge"; // Adjust the import path as needed

const Megamenu: React.FC = () => {
  const renderMenuItems = (items: MenuItem[]) => {
    if (!items || items.length === 0) {
      return <li>No menu items available</li>;
    }

    return items.map((item) => (
      <li
        key={`${item.name}-${item.link || item.name}`}
        className="group relative px-3 py-2"
      >
        <div className="flex items-center">
          {/* <Link
            href={item.link || `/${item.name}`}
            className="cursor-pointer hover:opacity-50"
          > */}
          <span className="cursor-pointer hover:opacity-50">{item.name}</span>
          {/* </Link> */}
          <div>
            <FaCaretDown />
          </div>
        </div>
        {item.subItems && (
          <div className="invisible absolute left-1/2 top-full z-50 min-w-[700px] max-w-[1200px] -translate-x-1/2 translate-y-0 pt-4 opacity-0 transition duration-500 ease-in-out group-hover:visible group-hover:translate-y-0 group-hover:opacity-100">
            <div className="relative w-full rounded-xl bg-white p-4 shadow-xl">
              <div className="absolute left-1/2 top-0 z-0 size-4 -translate-x-1/2 -translate-y-1/2 rotate-45 bg-white"></div>
              <div className="relative z-10">
                {/* Parent category */}

                <div className="grid grid-cols-2 gap-4">
                  {/* Sub-categories with their details */}
                  {item.subItems.map((subItem) => (
                    <div
                      key={`${subItem.title}-${subItem.slug}`}
                      className="ml-4"
                    >
                      <div className="text-xs font-light text-gray-500">
                        {subItem.title}
                      </div>
                      <ul className="ml-4 mt-2">
                        {subItem.details.map((detail) => (
                          <li
                            key={`${detail.itemName}-${detail.link}`}
                            className="text-xs"
                          >
                            <Link
                              href={
                                detail.customlink
                                  ? `${detail.customlink}`
                                  : `/${subItem.slug}/${detail.link}`
                              }
                              key={detail.itemName}
                              className="block py-1 text-gray-600"
                            >
                              <div className="flex flex-col px-2 hover:bg-gray-100">
                                <div className="text-sm font-semibold">
                                  {detail.itemName}
                                </div>
                                <div>
                                  {detail.description && (
                                    <span className="text-xs font-light text-gray-400">
                                      {detail.description}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </div>
                  ))}
                  <div>{item.subItems.length === 1 && <TwoButtonsLarge />}</div>
                </div>
              </div>
            </div>
          </div>
        )}
      </li>
    ));
  };

  return (
    <nav className="font-exo2">
      <ul className="flex items-center justify-center text-sm font-semibold">
        {renderMenuItems(menuItems)}
        <li className="group relative p-2">
          <CallPhone />
        </li>
      </ul>
    </nav>
  );
};

export default Megamenu;
